import { TranslationOptions } from 'owa-outlook-service-options';
import { mutatorAction } from 'satcheljs';

export default mutatorAction('setTranslationMode', function setTranslationMode(
    userOptions: TranslationOptions,
    newTranslationMode: number
) {
    userOptions.translationMode = newTranslationMode;
});
